import { withHandlers, compose } from 'recompose'
import CheckboxList from 'components/common/FormElements/CheckboxList/CheckboxList'

const withControlHandlers = withHandlers({
  handleChange: ({
    onChange,
    value,
    placeholder
  }) =>
    (checkboxValue, checked) => {
      const newValue =
        checked ?
          [...value, checkboxValue].filter(value => value !== placeholder) :
          value.filter(value => value !== checkboxValue)

      onChange(newValue)
    }
})

export default compose(
  withControlHandlers
)(CheckboxList)
